// Question list for the beta feedback form (/external/beta-feedback/:lang/:userId).
//
// This file holds STRUCTURE only. Every user-facing string lives in src/i18n.js
// under the betaFeedback* namespace, keyed off the ids below:
//   question label → betaFeedbackQ_<questionId>
//   question help  → betaFeedbackQ_<questionId>_help   (only when help: true)
//
// The ids are also the payload keys, so renaming one here renames it in the
// data we collect. Do not rename without the analyst's agreement.
//
// 2026-09-17: replaced the branching multiple-choice form (a fork question plus
// two sets of rating/choice questions) with three open questions. Picking from a
// list told us which of OUR guesses people recognised; it could not tell us
// anything we had not already thought of, which is the whole point of asking 14
// people who used the app.

export const TYPE = {
    TEXT: 'textarea',
};

export const QUESTIONS = [
    {
        // The one required answer. The invite email promises "the only required
        // question is the first one", so this must stay the first and only
        // required one unless that copy changes too.
        id: 'liked_most',
        type: TYPE.TEXT,
        required: true,
        help: true,
    },
    {
        id: 'liked_least',
        type: TYPE.TEXT,
        required: false,
        help: true,
    },
    {
        id: 'one_feature',
        type: TYPE.TEXT,
        required: false,
        help: true,
    },
];
